import { register } from './register'


export const InfaceSDK = {
    register
}

export default {
    InfaceSDK
}